import IconProps from "./icon-props";

export default function MenuIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.75 6.24658C3.75 5.55623 4.30964 4.99658 5 4.99658H25C25.6904 4.99658 26.25 5.55623 26.25 6.24658C26.25 6.93694 25.6904 7.49658 25 7.49658H5C4.30964 7.49658 3.75 6.93694 3.75 6.24658ZM11.25 14.9966C11.25 14.3062 11.8096 13.7466 12.5 13.7466H25C25.6904 13.7466 26.25 14.3062 26.25 14.9966C26.25 15.6869 25.6904 16.2466 25 16.2466H12.5C11.8096 16.2466 11.25 15.6869 11.25 14.9966ZM3.75 23.7466C3.75 23.0562 4.30964 22.4966 5 22.4966H25C25.6904 22.4966 26.25 23.0562 26.25 23.7466C26.25 24.4369 25.6904 24.9966 25 24.9966H5C4.30964 24.9966 3.75 24.4369 3.75 23.7466Z" fill="#131834" />
    </svg>

  )
}